import React from 'react';
import Switch, { ReactSwitchProps } from 'react-switch';
import colors from '../../styles/colors';

import { Container } from './styles';

interface ISwitchButton extends ReactSwitchProps {
  children?: any;
}

const SwitchButton: React.FC<ISwitchButton> = ({
  checked,
  disabled,
  onChange,
  children,
}) => {
  return (
    <Container>
      <span>{children}</span>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        onColor={colors.primaryLight}
        onHandleColor={colors.primary}
        handleDiameter={25}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={15}
        width={42}
        id="switch"
      />
    </Container>
  );
};

export default SwitchButton;
